module.exports = __webpack_public_path__ + "img/4-3.72fd8db0.svg";